/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Results_NameInputs */

const en_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Results`)
};

const fr_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats de la reconnaissance optique de caractères (OCR)`)
};

const de_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Ergebnisse`)
};

const it_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati OCR`)
};

const ru_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты OCR`)
};

const es_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de OCR`)
};

const zh_cn2_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR结果`)
};

const ja_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCRの結果`)
};

const hi_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर परिणाम`)
};

const pt_pt2_ocr_results_name = /** @type {(inputs: Ocr_Results_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de OCR`)
};

/**
* | output |
* | --- |
* | "OCR Results" |
*
* @param {Ocr_Results_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_results_name = /** @type {((inputs?: Ocr_Results_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Results_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_results_name(inputs)
	if (locale === "de") return de_ocr_results_name(inputs)
	if (locale === "it") return it_ocr_results_name(inputs)
	if (locale === "ru") return ru_ocr_results_name(inputs)
	if (locale === "es") return es_ocr_results_name(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_results_name(inputs)
	if (locale === "ja") return ja_ocr_results_name(inputs)
	if (locale === "hi") return hi_ocr_results_name(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_results_name(inputs)
	return en_ocr_results_name(inputs)
});